import { render } from "./ReorderBlocksModal.vue?vue&type=template&id=41e96a64&scoped=true"
import script from "./ReorderBlocksModal.vue?vue&type=script&lang=js"
export * from "./ReorderBlocksModal.vue?vue&type=script&lang=js"

import "./ReorderBlocksModal.vue?vue&type=style&index=0&id=41e96a64&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e96a64"]])

export default __exports__